import AddBuilding from "../Page/Owner/Building/AddBuilding";
import Dashboard from "../Page/Owner/OwnerPartnerDashboard/Dashboard";

import BuildingDetails from "../Page/Owner/Building/BuildingDetails";
import Addunits from "../Page/Owner/Units/Addunits";

import RequestDetails from "../Page/Owner/Request/RequestDetails";
import AddTask from "../Page/Owner/Task/AddTask";

import TaskDetails from "../Page/Owner/Task/TaskDetails";
import UnitDetails from "../Page/Owner/Units/UnitDetails";

import AddProfileGobal from "../Components/Global/AddProfileGobal";
import BankInformations from "../Components/Global/BankInformations";
import DetailsProfileGlobal from "../Components/Global/DetailsProfileGlobal";
import ViewProfileListGlobal from "../Components/Global/ViewProfileListGlobal";
import AllPropertyList from "../Components/Payments/AllPropertyList";
import AllUnitList from "../Components/Payments/AllUnitList";
import AllTaxsAccountantPr from "../Page/Accountant/Others/AllTaxsAccountantPr";
import OtherCollectionEditAccountPr from "../Page/Accountant/Others/OtherCollectionEditAccountPr";
import OthersAccountProfile from "../Page/Accountant/Others/OthersAccountProfile";
import RentCollectionAccountProfile from "../Page/Accountant/Rent/RentCollectionAccountProfile";
import RevenueAccountantProfile from "../Page/Accountant/Revenue/RevenueAccountantProfile";
import RevenueDetailsAccountantProfile from "../Page/Accountant/Revenue/RevenueDetailsAccountantProfile";

export const OwnerRoutes = [
  {
    path: "/dashboard",
    Component: <Dashboard key={11} allowedRoles={["Owner", "Partner"]} />,
    Title: "Dashboard",
  },
  {
    path: "/addbuilding",
    Component: <AddBuilding key={1} allowedRoles={["Owner", "Partner"]} />,
    Title: "AddBuilding",
  },
  {
    path: "/addbuilding/:id",
    Component: <AddBuilding key={2} allowedRoles={["Owner", "Partner"]} />,
    Title: "AddBuildingId",
  },
  {
    path: "/building-details/:id",
    Component: <BuildingDetails key={2} allowedRoles={["Owner", "Partner"]} />,
    Title: "BuildingDetails",
  },
  {
    path: "/buildinglist",
    Component: (
      <ViewProfileListGlobal
        key={343431434}
        allowedRoles={["Owner", "Partner"]}
      />
    ),
    Title: "Viewbuilding",
  },
  {
    path: "/add-units/:id",
    Component: <Addunits key={2} allowedRoles={["Owner", "Partner"]} />,
    Title: "Addunits",
  },
  {
    path: "/unit-details/:id",
    Component: <UnitDetails allowedRoles={["Owner", "Partner"]} />,
    Title: "UnitDetails",
  },
  {
    path: "/addpartner",
    Component: <AddProfileGobal key={1} allowedRoles={["Owner", "Partner"]} />,
    Title: "AddPartner",
  },
  {
    path: "/addpartner/:id",
    Component: <AddProfileGobal key={2} allowedRoles={["Owner", "Partner"]} />,
    Title: "AddPartnerid",
  },
  {
    path: "/partnerlist",
    Component: (
      <ViewProfileListGlobal key={124444} allowedRoles={["Owner", "Partner"]} />
    ),
    Title: "ViewPartner",
  },
  {
    path: "/partner-details/:id",
    Component: (
      <DetailsProfileGlobal key={11111} allowedRoles={["Owner", "Partner"]} />
    ),
    Title: "DetailsProfileGlobal",
  },
  {
    path: "/addmanager",
    Component: <AddProfileGobal key={3} allowedRoles={["Owner", "Partner"]} />,
    Title: "AddManager",
  },
  {
    path: "/addmanager/:id",
    Component: <AddProfileGobal key={4} allowedRoles={["Owner", "Partner"]} />,
    Title: "AddManagerid",
  },
  {
    path: "/manager-details/:id",
    Component: (
      <DetailsProfileGlobal key={22222} allowedRoles={["Owner", "Partner"]} />
    ),
    Title: "ViewManager",
  },
  {
    path: "/managerlist",
    Component: (
      <ViewProfileListGlobal
        key={1333333}
        allowedRoles={["Owner", "Partner"]}
      />
    ),
    Title: "ViewProfileListGlobal",
  },
  {
    path: "/addtenant",
    Component: (
      <AddProfileGobal key={56546541} allowedRoles={["Owner", "Partner"]} />
    ),
    Title: "AddTenant",
  },
  {
    path: "/addtenant/:id",
    Component: (
      <AddProfileGobal key={54654654652} allowedRoles={["Owner", "Partner"]} />
    ),
    Title: "AddTenantid",
  },
  {
    path: "/tenant-details/:id",
    Component: (
      <DetailsProfileGlobal key={23543} allowedRoles={["Owner", "Partner"]} />
    ),
    Title: "TenantDetails",
  },
  {
    path: "/tenantlist",
    Component: (
      <ViewProfileListGlobal
        key={134342343223}
        allowedRoles={["Owner", "Partner"]}
      />
    ),
    Title: "ViewTenant",
  },
  {
    path: "/addaccountant",
    Component: <AddProfileGobal key={6} allowedRoles={["Owner", "Partner"]} />,
    Title: "AddAccountant",
  },
  {
    path: "/addaccountant/:id",
    Component: <AddProfileGobal key={7} allowedRoles={["Owner", "Partner"]} />,
    Title: "AddAccountantid",
  },
  {
    path: "/accountant-details/:id",
    Component: (
      <DetailsProfileGlobal key={233333} allowedRoles={["Owner", "Partner"]} />
    ),
    Title: "AccountantDetails",
  },
  {
    path: "/accountantlist",
    Component: (
      <ViewProfileListGlobal key={122222} allowedRoles={["Owner", "Partner"]} />
    ),
    Title: "ViewProfileListGlobal",
  },
  {
    path: "/addworker",
    Component: <AddProfileGobal key={8} allowedRoles={["Owner", "Partner"]} />,
    Title: "Addworker",
  },
  {
    path: "/addworker/:id",
    Component: <AddProfileGobal key={9} allowedRoles={["Owner", "Partner"]} />,
    Title: "Addworkerid",
  },
  {
    path: "/workerlist",
    Component: (
      <ViewProfileListGlobal key={11111} allowedRoles={["Owner", "Partner"]} />
    ),
    Title: "ViewProfileListGlobal",
  },
  {
    path: "/worker-details/:id",
    Component: (
      <DetailsProfileGlobal key={24444} allowedRoles={["Owner", "Partner"]} />
    ),
    Title: "WorkerDetails",
  },
  {
    path: "/view-request",
    Component: (
      <ViewProfileListGlobal key={16666} allowedRoles={["Owner", "Partner"]} />
    ),
    Title: "ViewRequest",
  },
  {
    path: "/request-details/:id",
    Component: <RequestDetails key={2} allowedRoles={["Owner", "Partner"]} />,
    Title: "RequestDetails",
  },
  {
    path: "/addtask",
    Component: <AddTask key={1} allowedRoles={["Owner", "Partner"]} />,
    Title: "AddTask",
  },
  {
    path: "/addtask/:id",
    Component: <AddTask key={2} allowedRoles={["Owner", "Partner"]} />,
    Title: "AddTaskid",
  },
  {
    path: "/tasklist",
    Component: (
      <ViewProfileListGlobal key={556513} allowedRoles={["Owner", "Partner"]} />
    ),
    Title: "TaskList",
  },
  {
    path: "/task-details/:id",
    Component: <TaskDetails key={2} allowedRoles={["Owner", "Partner"]} />,
    Title: "TaskDetails",
  },
  // {
  //     path: "owner/all-taxation",
  //     Component: <AllTaxsAccountantPr />,
  //     Title: 'AllTaxsAccountantPr',
  // },

  {
    path: "owner/taxation-information",
    Component: (
      <AllTaxsAccountantPr
        key="owner33/taxation-information"
        allowedRoles={["Owner"]}
      />
    ),
    Title: "TaxDetailsAccountantPr",
  },
  {
    path: "partner/taxation-information",
    Component: (
      <AllTaxsAccountantPr
        key="partnerowner/taxation-information"
        allowedRoles={["Partner"]}
      />
    ),
    Title: "TaxDetailsAccountantPr",
  },
  {
    path: "owner/banking-information",
    Component: <BankInformations allowedRoles={["Owner", "Partner"]} />,
    Title: "BanksNameAccountantPr",
  },
 
  {
    path: "owner/cash-management",
    Component: <OthersAccountProfile allowedRoles={["Owner", "Partner"]} />,
    Title: "OthersAccountProfile",
  },
  {
    path: "owner/rent/collection-management",
    Component: (
      <AllPropertyList
        key={54684685435}
        allowedRoles={["Owner", "Partner"]}
      />
    ),
    Title: "PropertyListAccountProfile",
  },
  {
    path: "partner/rent/collection-management",
    Component: (
      <AllPropertyList
        key={5468468543554545}
        allowedRoles={["Owner", "Partner"]}
      />
    ),
    Title: "PropertyListAccountProfile",
  },
  {
    path: "owner/revenue-details/:tenantid",
    Component: (
      <RevenueDetailsAccountantProfile allowedRoles={["Owner", "Partner"]} />
    ),
    Title: "RevenueDetailsAccountantProfile",
  },
  {
    path: "partner/revenue-details/:tenantid",
    Component: (
      <RevenueDetailsAccountantProfile allowedRoles={["Owner", "Partner"]} />
    ),
    Title: "RevenueDetailsAccountantProfile",
  },
  {
    path: "owner/revenue",
    Component: (
      <RevenueAccountantProfile
        allowedRoles={["Owner", "Partner"]}
        key="owner/revenue"
      />
    ),
    Title: "RevenueAccountantProfile",
  },
  {
    path: "owner/miscellaneous/collection/:id",
    Component: (
      <OtherCollectionEditAccountPr allowedRoles={["Owner", "Partner"]} />
    ),
    Title: "OtherCollectionEditAccountPr",
  },
  {
    path: "owner/collection-management/:id",
    Component: (
      <AllUnitList allowedRoles={["Owner", "Partner"]} />
    ),
    Title: "PropertyDetailsAccountProfile",
  },
  {
    path: "partner/collection-management/:id",
    Component: (
      <AllUnitList allowedRoles={["Owner", "Partner"]} />
    ),
    Title: "PropertyDetailsAccountProfile",
  },
  {
    path: "owner/rent-collection/:id",
    Component: (
      <RentCollectionAccountProfile allowedRoles={["Owner", "Partner"]} />
    ),
    Title: "RentCollectionAccountProfile",
  },
  {
    path: "partner/rent-collection/:id",
    Component: (
      <RentCollectionAccountProfile allowedRoles={["Owner", "Partner"]} />
    ),
    Title: "RentCollectionAccountProfile",
  },
];
